var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32.5","r":"31.5","stroke":"#fff","key":0}),React.createElement("path",{"d":"M26.74 20.693 42.68 32.5 26.74 44.307V20.693Z","stroke":"#fff","key":1})]);
}

PlayInline.defaultProps = {"width":"64","height":"65","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
